import { Component, Vue } from 'vue-property-decorator';
import { PaymentHistoryPayrollStatus } from './interface';
import { PaymentRequirementsOutgoingStatus } from '@/feature/PaymentRequirements/api/incoming/payment-requirements-incoming.interface';

@Component
export default class IBPaymentStateMixin extends Vue {
    
    payrollPositiveStatus: PaymentHistoryPayrollStatus[] = [
		PaymentHistoryPayrollStatus.INTRODUCED_INCOMING,
		PaymentHistoryPayrollStatus.APPROVED,
		PaymentHistoryPayrollStatus.CONDUCTED_INCOMING,
		PaymentHistoryPayrollStatus.SENT_TO_TCR,
		PaymentHistoryPayrollStatus.SENT_TO_GO,
	];

    payrollNegativeStatus: PaymentHistoryPayrollStatus[] = [
		PaymentHistoryPayrollStatus.DRAFT,
		PaymentHistoryPayrollStatus.DELETED_BY_DIRECTOR,
		PaymentHistoryPayrollStatus.ON_DIRECTOR_LIST,
		PaymentHistoryPayrollStatus.ON_ACCOUNTANT_LIST,
		PaymentHistoryPayrollStatus.DELETED_BY_ACCOUNTANT,
		PaymentHistoryPayrollStatus.UNDEFINED,
		PaymentHistoryPayrollStatus.SENDING_TO_THE_BANK,
		PaymentHistoryPayrollStatus.DELETED_BY_BANK,
		PaymentHistoryPayrollStatus.REJECTED_TCR,
		PaymentHistoryPayrollStatus.UNREJECTED,
		PaymentHistoryPayrollStatus.POSTPONED_INCOMING,
	];

	outgoingErrorPaymentStatus: string[] = [
		PaymentRequirementsOutgoingStatus.UNDEFINED,
		PaymentRequirementsOutgoingStatus.REMOVED,
		PaymentRequirementsOutgoingStatus.REJECTED_BY_BOARD_BANK,
		PaymentRequirementsOutgoingStatus.DENIED,
		PaymentRequirementsOutgoingStatus.PROCESSING_TIME_EXPIRED
	]
}